import { OptionInfoList } from '../data-models/option-info.interfaces';

export function createYearList(): OptionInfoList[] {
  const year = [{ code: '', description: 'YYYY' }];
  const today = new Date();
  const currentYear = today.getFullYear();
  const beginYear = currentYear - 114;
  for (let i = currentYear; i > beginYear; i--) {
    year.push({ code: i.toString(), description: i.toString() });
  }
  return year;
}
